import { toCodePointChar } from "#to-code-point-char";

/** Matches a leading Private Use code point (general category Co). */
export const PRIVATE_USE_REGEX = /^\p{Private_Use}/u;

/**
 * True if the first code point is Private Use (general category Co): U+E000–U+F8FF,
 * U+F0000–U+FFFFD, U+100000–U+10FFFD.
 */
export function isPrivateUse(value: string | number): boolean {
  return PRIVATE_USE_REGEX.test(toCodePointChar(value));
}
